import { MarketoUserInputMetaObject } from "../../types/definitions/inputs/marketo-input-meta.js";
import { type MarketoUserInputMeta } from "../../types/definitions/inputs/marketo-input-meta.js";
import { createEnumFromKeys, type EnumFromKeys } from "@mcwd/typescript-type-guards";

import { getTypedObjectKeys } from "@mcwd/typescript-type-guards";

// Get all of the names of marketo user inputs.
type EclipseUserInputNames = MarketoUserInputMeta["name"];

const EclipseUserInputNames =
  getTypedObjectKeys(MarketoUserInputMetaObject)
  .map(k => MarketoUserInputMetaObject[k].name) satisfies EclipseUserInputNames[];

// Specify that a label is needed for all of the user inputs plus any extra nested translations
export const FormLabelKeys = [
  ...EclipseUserInputNames,
  "privacyStatement",
  "privacyNewsletterOptIn",
  /** This translation is linked to from the "eclipse_Email_Opt_In__c" and "privacyStatement" translations */
  "privacyPolicyLinkText",
  "eclipse_Entity",
  "eclipse_NonBusinessEmail"
] as const;

export type FormLabelKeys = (typeof FormLabelKeys)[number];

// Create an object enum to more easily access a translation name when the property or attribute we are assigning to is not typed
export type FormLabelKeysEnum = EnumFromKeys<FormLabelKeys, true>
export const FormLabelKeysEnum = createEnumFromKeys(FormLabelKeys, true);

export const privacyPolicySlotName = "privacy-policy-link-slot" as const;

// Create a specific pattern for translations containing the privacy policy link slot.
type TranslationWithPrivacyPolicySlot<
  BeforeText extends string = string,
  AfterText extends string = ""
> = `${BeforeText}{${typeof privacyPolicySlotName}}${AfterText}`;

// Specify types for any translations that should follow a specific pattern
type SpecificFormLabelTypes = {
  [FormLabelKeysEnum.eclipse_Email_Opt_In__c]: TranslationWithPrivacyPolicySlot<string, string>;
  [FormLabelKeysEnum.privacyStatement]: TranslationWithPrivacyPolicySlot<string, string>;

};
// Get the keys of translations that we want to give a more specific type than "string".
type SpecificFormLabelTypeKeys = keyof SpecificFormLabelTypes;

export type FormLabelTranslationsObject = {
  readonly [Key in FormLabelKeys]: Key extends SpecificFormLabelTypeKeys ? SpecificFormLabelTypes[Key] : string;
};